import { Flex, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface InfoBoxProps {
  children: ReactNode;
}

export const InfoBox: React.FC<InfoBoxProps> = ({ children }) => {
  return (
    <Flex
      align="flex-start"
      gap={3}
      p={4}
      bg="white"
      borderRadius="lg"
    >
      <Flex
        align="center"
        justify="center"
        w="24px"
        h="24px"
        minW="24px"
        borderRadius="full"
        bg="green.600"
        color="white"
        fontSize="sm"
        fontWeight="bold"
      >
        i
      </Flex>
      <Text fontSize="sm" color="gray.700" lineHeight="1.5">
        {children}
      </Text>
    </Flex>
  );
};
